import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .EditStrategy {
    &__content {
      width: 450px;
      max-width: 100%;
    }
  }

  .EditInvestStrategyForm {
    .caption {
      margin-bottom: 10px;
    }

    &__btns {
      display: flex;
      justify-content: space-between;

      :global(.DefaultButton) {
        width: calc(50% - 10px);
        display: flex;
        justify-content: center;
      }
    }

    .row {
      display: flex;
      justify-content: space-between;

      :global(.BaseSelectField) {
        width: 48%;
      }
      :global(.BaseTextField) {
        width: 48%;
      }
    }

    .formError {
      color: #e33046;
      margin-bottom: 25px;
    }
  }

  .EditStrategy {
    &__min-invest-amount {
    }

    &__min-invest-amount-text {
      font-size: 12px;
      line-height: 18px;
      color: #777777;
      margin: -28px 0 20px 0;
    }

    :global(.ReduxTextField.error + &__min-invest-amount-text) {
      margin: -12px 0 20px 0;
    }

    &__autoinvestment {
      margin: 0 0 25px 0;
    }

    &__enableoperations {
      margin: 0 0 25px 0;
    }
  }

  .mce-edit-area > iframe {
    min-height: rem(200px) !important;
    height: auto !important;
  }
`;

export default staticStyles;
